var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import axios from "axios";
import { LOCAL_STORAGE_KEYS } from "../constants";
import { clearLocalStorage, getLocalStorageItem, getUserAuthToken, getWhoAmIToken } from "../utils/storageHelper";
import { GoogleAnlyticsAPICallsTimeLog, handleServerSideErrors } from "../utils/utils";
import { Config, env } from "./config";
import { showNotification } from "../redux/commonSlice";
import { ChitraLogout } from "../modules/reports/utils";
var userToken = getUserAuthToken();
var options = {
    // baseURL: config.BASE_URL,
    headers: {
        Authorization: "Bearer ".concat(userToken)
    },
    timeout: 60000,
    withCredentials: true
};
var instance = axios.create(options);
// Add a request interceptor
instance.interceptors.request.use(function (config) { return __awaiter(void 0, void 0, void 0, function () {
    var authData, tokenData, storedSelectedChannel;
    return __generator(this, function (_a) {
        authData = getUserAuthToken();
        tokenData = authData ? authData : getWhoAmIToken();
        storedSelectedChannel = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
        config.metadata = {
            startTime: new Date()
        };
        if (tokenData) {
            config.headers["Authorization"] = "Bearer ".concat(tokenData);
            config.headers["Subscription"] = Config.Subscription;
        }
        if (!config.headers["Content-Type"]) {
            config.headers["Content-Type"] = "application/json";
        }
        config.headers["Access-Control-Allow-Credentials"] = true;
        config.headers["ChannelId"] = storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelId;
        return [2 /*return*/, config];
    });
}); }, function (error) {
    return Promise.reject(error);
});
// Add a response interceptor
instance.interceptors.response.use(function (response) {
    // GoogleAnlyticsAPICallsTimeLog(profileData, response)
    return response;
}, function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var _error$response;
    return __generator(this, function (_a) {
        if ((error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.statusCode) === 401 && getUserAuthToken()) {
            clearLocalStorage();
            window.location.href = '/';
            if (env === "dev" || env === "lt") {
                ChitraLogout();
            }
            window.location.reload();
            // const currentUrl = window.location.href.split('?')[0];
            // window.location.href = `${currentUrl}?_=${new Date().getTime()}`;
            return [2 /*return*/, Promise.reject(error)];
        }
        return [2 /*return*/, Promise.reject(error)];
    });
}); });
export var Get = function (url, config) {
    return new Promise(function (resolve, reject) {
        instance.get(url, config).then(function (result) {
            var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
            instance.interceptors.response.use(function (response) {
                GoogleAnlyticsAPICallsTimeLog(profileData, response, config === null || config === void 0 ? void 0 : config.params);
                return response;
            });
            if (result.status === 200 || result.status === 201) {
                resolve(result.data);
            }
            else {
                reject(result.data);
            }
        }).catch(function (error) {
            var _error$request, _error$request2;
            var err = error !== null && error !== void 0 && (_error$request = error.request) !== null && _error$request !== void 0 && _error$request.response ? JSON.parse(error === null || error === void 0 || (_error$request2 = error.request) === null || _error$request2 === void 0 ? void 0 : _error$request2.response) : error;
            reject(err);
        });
    });
};
export var GetImage = function (url, config) {
    return new Promise(function (resolve, reject) {
        instance.get(url, config).then(function (result) {
            var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
            instance.interceptors.response.use(function (response) {
                GoogleAnlyticsAPICallsTimeLog(profileData, response, config === null || config === void 0 ? void 0 : config.params);
                return response;
            });
            if (result.status === 200 || result.status === 201) {
                var reader_1 = new window.FileReader();
                reader_1.readAsDataURL(result.data);
                reader_1.onload = function () {
                    var imageDataUrl = reader_1.result;
                    resolve(imageDataUrl);
                };
            }
            else {
                reject(result.data);
            }
        }).catch(function (error) {
            var _error$request3, _error$request4;
            var err = error !== null && error !== void 0 && (_error$request3 = error.request) !== null && _error$request3 !== void 0 && _error$request3.response ? JSON.parse(error === null || error === void 0 || (_error$request4 = error.request) === null || _error$request4 === void 0 ? void 0 : _error$request4.response) : error;
            reject(err);
        });
    });
};
export var Put = function (url, data, config) {
    return new Promise(function (resolve, reject) {
        instance.put(url, data, config).then(function (result) {
            var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
            instance.interceptors.response.use(function (response) {
                GoogleAnlyticsAPICallsTimeLog(profileData, response, data);
                return response;
            });
            if (result.status === 200 || result.status === 201) {
                resolve(result.data);
            }
            else {
                reject(result.data);
            }
        }).catch(function (error) {
            var _error$request5, _error$request6;
            var err = error !== null && error !== void 0 && (_error$request5 = error.request) !== null && _error$request5 !== void 0 && _error$request5.response ? JSON.parse(error === null || error === void 0 || (_error$request6 = error.request) === null || _error$request6 === void 0 ? void 0 : _error$request6.response) : error;
            reject(err);
        });
    });
};
export var Post = function (url, data, config) {
    return new Promise(function (resolve, reject) {
        instance.post(url, data, config).then(function (result) {
            var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
            instance.interceptors.response.use(function (response) {
                GoogleAnlyticsAPICallsTimeLog(profileData, response, data);
                return response;
            });
            if (result.status === 200 || result.status === 201) {
                resolve(result.data);
            }
            else {
                reject(result.data);
            }
        }).catch(function (error) {
            var _error$request7, _error$request8;
            var err = error !== null && error !== void 0 && (_error$request7 = error.request) !== null && _error$request7 !== void 0 && _error$request7.response ? JSON.parse(error === null || error === void 0 || (_error$request8 = error.request) === null || _error$request8 === void 0 ? void 0 : _error$request8.response) : error;
            reject(err);
        });
    });
};
export var Delete = function (url, data, config) {
    return new Promise(function (resolve, reject) {
        instance.delete(url, config).then(function (result) {
            if (result.status === 200 || result.status === 201) {
                resolve(result.data);
            }
            else {
                reject(result.data);
            }
        }).catch(function (error) {
            var _error$request9, _error$request10;
            var err = error !== null && error !== void 0 && (_error$request9 = error.request) !== null && _error$request9 !== void 0 && _error$request9.response ? JSON.parse(error === null || error === void 0 || (_error$request10 = error.request) === null || _error$request10 === void 0 ? void 0 : _error$request10.response) : error;
            reject(err);
        });
    });
};
export var UploadImage = function (url, data, systemName, dispatch, config) {
    return new Promise(function (resolve, reject) {
        var updatedConfig = _objectSpread(_objectSpread({}, config), {}, {
            headers: _objectSpread(_objectSpread({}, config === null || config === void 0 ? void 0 : config.headers), {}, {
                "Content-Type": "multipart/form-data",
                "systemname": systemName === 'BlankSystemName' ? "" : systemName !== null && systemName !== void 0 ? systemName : null
            })
        });
        instance.post(url, data, updatedConfig).then(function (result) {
            if (result.status === 200 || result.status === 201) {
                resolve(result.data);
            }
            else {
                reject(result.data);
            }
        }).catch(function (error) {
            var _error$request11, _error$request12;
            var err = error !== null && error !== void 0 && (_error$request11 = error.request) !== null && _error$request11 !== void 0 && _error$request11.response ? JSON.parse(error === null || error === void 0 || (_error$request12 = error.request) === null || _error$request12 === void 0 ? void 0 : _error$request12.response) : error;
            dispatch(showNotification({
                isOpen: true,
                message: handleServerSideErrors(err, url),
                type: "error"
            }));
            reject(err);
        });
    });
};
export var GetFile = function (url, config) {
    return new Promise(function (resolve, reject) {
        instance.get(url, config).then(function (result) {
            if (result.status === 200 || result.status === 201) {
                resolve(result);
            }
            else {
                reject(result);
            }
        }).catch(function (error) {
            var _error$request13, _error$request14;
            var err = error !== null && error !== void 0 && (_error$request13 = error.request) !== null && _error$request13 !== void 0 && _error$request13.response ? JSON.parse(error === null || error === void 0 || (_error$request14 = error.request) === null || _error$request14 === void 0 ? void 0 : _error$request14.response) : error;
            reject(err);
        });
    });
};
export var API = {
    Get: Get,
    Put: Put,
    Post: Post,
    Delete: Delete,
    GetImage: GetImage,
    UploadImage: UploadImage
};
